export default __webpack_public_path__ + "static/media/v-shield.65536ab8.png";